<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (!isLoading && loadingSuccess) {
    @if (rulings.length > 0) {
        <div class="flex flex-col gap-2 text-xs">
            <!-- todo hide rulings on mobile first, and show optional? -->
            @for (ruling of rulings ; track ruling.text) {
                @if (($index < initialMax || showAll) && ruling.text) {
                    <div class="flex flex-col pl-2 pr-2 pb-1 pt-1 gap-1 rounded shadow-sm" [ngClass]="{ 'bg-slate-50' : $odd, 'bg-white' : $even }">
                        <div class="font-bold">
                            {{ getDateStr(ruling) }}
                        </div>
                        <div class="break-words" [innerHTML]="ruling.text | magicmarkdown: true">
                            
                        </div>
                    </div>
                }
            }
            @if (rulings.length > initialMax && !showAll) {
                <button (click)="onShowAllClicked()" class="p-1 bg-white rounded shadow-sm text-center border border-transparent hover:border-ponder-linkhover">
                    Show All {{ rulings.length }} Rulings
                </button>
            }
        </div>
    } @else {
        <div class="flex items-center align-middle justify-center text-sm text-center text-slate-400 min-h-12 bg-slate-50 p-2 shadow-sm">
            None
        </div>
    }
}